import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface ReferralData {
  code: string;
  timestamp: string;
  clickId?: string;
}

export const useReferralTracking = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleReferralTracking = async () => {
      const refCode = searchParams.get('ref');
      
      if (refCode) {
        
        try {
          // Track the click in the database
          const clickData = {
            affiliateCode: refCode,
            clickData: {
              ipAddress: await getClientIP(),
              userAgent: navigator.userAgent,
              referrerUrl: document.referrer,
              landingPage: window.location.href,
              sessionId: generateSessionId()
            }
          };

          // Call the affiliate tracking API
          const { error } = await supabase.functions.invoke('affiliate-management/track-click', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(clickData)
          });

          if (error) {
          } else {
          }

          // Store in localStorage for attribution (30-day expiration)
          const referralData: ReferralData = {
            code: refCode,
            timestamp: new Date().toISOString()
          };

          localStorage.setItem('posit_referral', JSON.stringify(referralData));

        } catch (error) {
        }
      }
    };

    handleReferralTracking();
  }, [searchParams]);

  // Helper function to get stored referral data
  const getStoredReferral = (): ReferralData | null => {
    try {
      const stored = localStorage.getItem('posit_referral');
      if (!stored) return null;

      const referralData: ReferralData = JSON.parse(stored);
      
      // Check if referral is still valid (30 days)
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      
      if (new Date(referralData.timestamp) < thirtyDaysAgo) {
        localStorage.removeItem('posit_referral');
        return null;
      }

      return referralData;
    } catch {
      return null;
    }
  };

  // Clear referral data (used after successful attribution)
  const clearReferral = () => {
    localStorage.removeItem('posit_referral');
  };

  return {
    getStoredReferral,
    clearReferral
  };
};

// Helper functions
async function getClientIP(): Promise<string> {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip || 'unknown';
  } catch {
    return 'unknown';
  }
}

function generateSessionId(): string {
  return 'sess_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
} 